module.exports = __webpack_public_path__ + "static/media/um.2da266d7.svg";